import React from "react";

import { useModalStore } from "../zustand/modal";
import calculationList from "../constants/calculation";
import { useProjectStore } from "../zustand/priceTagSystem/project";
import { useEstimateStore } from "../zustand/priceTagSystem/estimate";

//components
import DefaultButton from "./DefaultButton";
import TextInput from "./TextInput";
import Portal from "../Portal";
import { notify } from "./alertToastify";

export default function SashAddModal(props) {
    const {
        sash_modal_is_open: is_open = false,
        sash_data: data,
        closeSashModal: closeModal,
    } = useModalStore();
    const { project_info, setProjectInfo } = useProjectStore();
    const { estimate_info, setEstimateInfo } = useEstimateStore();

    //샷시 데이터
    const temp = data?.temp;
    const category_name = temp?.[0]?.category_name;

    const current_data = project_info.addon.filter(
        (d) => d.category_name === category_name && d.input_type === "modal"
    );

    const table_header = ["", "가로(mm)", "세로(mm)", "자평", "가격", ""];

    function addSash() {
        if (project_info.is_final)
            return notify("진견적 책정 후에는 변경할 수 없습니다.", "warn");

        //샷시 추가
        const default_value = {
            ...temp[0],
            final_price: 0,
            quantity: 0,
            option: temp[0].option.map((o) => ({
                ...o,
                final_price: 0,
                quantity: 0,
            })),
        };

        setProjectInfo({
            ...project_info,
            addon: [...project_info.addon, default_value],
        });
        setEstimateInfo({
            ...estimate_info,
            addon: [...estimate_info.addon, default_value],
        });
    }

    function saveSashName({ row_idx, value }) {
        let project_cur_idx = -1;
        let estimate_cur_idx = -1;

        const cur_data = temp.find((d) => d.name === value);

        const project_temp = {
            ...project_info,
            addon: project_info.addon.map((d) => {
                if (
                    d.category_id === cur_data.category_id &&
                    d.input_type === "modal"
                ) {
                    project_cur_idx++;
                    if (row_idx === project_cur_idx) {
                        return {
                            ...cur_data,
                            option: cur_data.option.map((o) => ({
                                ...o,
                                quantity: 0,
                                final_price: 0,
                            })),
                        };
                    }
                    return d;
                }
                return d;
            }),
        };
        setProjectInfo(project_temp);

        const estimate_temp = {
            ...estimate_info,
            addon: estimate_info.addon.map((d) => {
                if (
                    d.category_id === cur_data.category_id &&
                    d.input_type === "modal"
                ) {
                    estimate_cur_idx++;
                    if (row_idx === estimate_cur_idx) {
                        return {
                            ...cur_data,
                            option: cur_data.option.map((o) => ({
                                ...o,
                                quantity: 0,
                                final_price: 0,
                            })),
                        };
                    }
                    return d;
                }
                return d;
            }),
        };
        setEstimateInfo(estimate_temp);
    }

    function saveSashData({ value, extraInfo }) {
        if (project_info.is_final)
            return notify("진견적 책정 후에는 변경할 수 없습니다.", "warn");

        const { row, option, row_idx } = extraInfo;
        let final_data = null;

        let project_cur_idx = -1;
        const project_temp = {
            ...project_info,
            addon: project_info.addon.map((d) => {
                if (
                    d.category_id === row.category_id &&
                    d.input_type === "modal"
                ) {
                    project_cur_idx++;
                    if (row_idx === project_cur_idx) {
                        //옵션저장
                        let new_data = {
                            ...d,
                            option: d.option.map((o) =>
                                o.option_id === option.option_id
                                    ? { ...o, quantity: value }
                                    : o
                            ),
                        };

                        //계산
                        const [width, length] = new_data.option.reduce(
                            (acc, cur) => {
                                if (cur.option_name === "가로")
                                    acc[0] = cur.quantity;
                                else if (cur.option_name === "세로")
                                    acc[1] = cur.quantity;
                                return acc;
                            },
                            [,]
                        );
                        const quantity = getSashQuantity({ width, length });
                        const final_price = getSashFinalPrice({
                            quantity,
                            price: row.price,
                            calculate_type: row.calculate_type,
                        });
                        new_data = {
                            ...new_data,
                            quantity,
                            final_price,
                        };
                        final_data = new_data; //estimate_info에도 똑같은 데이터가 들어가도록 저장하기!

                        return new_data;
                    }
                    return d;
                }
                return d;
            }),
        };
        setProjectInfo(project_temp);

        let estimate_cur_idx = -1;
        const estimate_temp = {
            ...estimate_info,
            addon: estimate_info.addon.map((d) => {
                if (
                    d.category_id === row.category_id &&
                    d.input_type === "modal"
                ) {
                    estimate_cur_idx++;
                    if (row_idx === estimate_cur_idx) {
                        return final_data;
                    }
                    return d;
                }
                return d;
            }),
        };
        setEstimateInfo(estimate_temp);
    }

    function deleteSash({ extraInfo }) {
        //샷시 삭제
        if (project_info.is_final)
            return notify("진견적 책정 후에는 변경할 수 없습니다.", "warn");

        const { row, row_idx } = extraInfo;

        let project_cur_idx = -1;
        const project_temp = {
            ...project_info,
            addon: project_info.addon.filter((d) => {
                if (d.category_id !== row.category_id) return d;
                if (
                    d.category_id === row.category_id &&
                    d.input_type === "modal"
                ) {
                    project_cur_idx++;
                    if (row_idx !== project_cur_idx) return d;
                }
            }),
        };

        setProjectInfo(project_temp);

        let estimate_cur_idx = -1;
        const estimate_temp = {
            ...estimate_info,
            addon: estimate_info.addon.filter((d) => {
                if (d.category_id !== row.category_id) return d;
                else {
                    if (
                        d.category_id === row.category_id &&
                        d.input_type === "modal"
                    ) {
                        estimate_cur_idx++;
                        if (row_idx !== estimate_cur_idx) return d;
                    }
                }
            }),
        };
        setEstimateInfo(estimate_temp);
    }

    if (!temp) return <div />;

    function getSashQuantity({ width = 0, length = 0 }) {
        //가로 세로 계산을 통해 샷시의 갯수를 정해주는 함수
        return Math.ceil((width / 300) * (length / 300));
    }

    function getSashFinalPrice({ quantity, price, calculate_type }) {
        const formula = calculationList.find(
            (calculation) => calculation.type === calculate_type
        ).formula;
        const req = {
            price,
            quantity,
        };
        return formula(req);
    }

    return (
        <Portal>
            <div className="bg-white fixed w-[700px] top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] z-[99] border border-black">
                <div className="py-[15px] px-[30px] flex justify-between items-center">
                    <h5 className="text-[24px] font-['spoqa_regular']">
                        샷시 상세 입력
                    </h5>
                    <div>
                        <DefaultButton
                            margin="0 20px 0 0"
                            height="40px"
                            width="100px"
                            onClick={addSash}
                        >
                            추가
                        </DefaultButton>
                        <DefaultButton
                            margin="0 20px 0 0"
                            height="40px"
                            width="100px"
                            onClick={closeModal}
                        >
                            적용
                        </DefaultButton>
                        <DefaultButton
                            height="40px"
                            width="100px"
                            backgroundColor="#c4c4c4"
                            onClick={closeModal}
                        >
                            취소
                        </DefaultButton>
                    </div>
                </div>

                <div
                    className="grid gap-[1px] bg-black border-t border-black"
                    style={{
                        gridTemplateColumns: `repeat(${table_header.length},1fr)`,
                    }}
                >
                    {table_header.map((name, idx) => (
                        <div
                            key={`table-header-${idx}`}
                            className="bg-[#c4c4c4] py-[10px] px-[20px]"
                        >
                            {name}
                        </div>
                    ))}
                    {current_data &&
                        current_data.map((d, row_idx) => {
                            return (
                                <React.Fragment
                                    key={`table-content-row${row_idx}`}
                                >
                                    <div className="bg-white py-[10px] px-[20px]">
                                        <select
                                            value={d.name}
                                            className="h-[30px]"
                                            onChange={(e) => {
                                                saveSashName({
                                                    row_idx,
                                                    value: e.target.value,
                                                });
                                            }}
                                        >
                                            {temp.map((t, idx) => (
                                                <option
                                                    key={`current_data${row_idx}-select-${idx}`}
                                                >
                                                    {t.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    {d.option.map((o) => (
                                        <div className="bg-white py-[10px] px-[20px]">
                                            <TextInput
                                                value={o.quantity}
                                                width="100%"
                                                type="number"
                                                name={o.option_name}
                                                extraInfo={{
                                                    row: d,
                                                    option: o,
                                                    row_idx,
                                                }}
                                                disabled={
                                                    project_info.is_final
                                                        ? true
                                                        : false
                                                }
                                                onChange={saveSashData}
                                            />
                                        </div>
                                    ))}

                                    <div className="bg-white py-[10px] px-[20px]">
                                        {d.quantity}
                                    </div>
                                    <div className="bg-white py-[10px] px-[20px]">
                                        {d.final_price
                                            ? d.final_price.toLocaleString()
                                            : 0}
                                    </div>
                                    <div className="bg-white py-[10px] px-[20px]">
                                        <DefaultButton
                                            height="30px"
                                            width="50px"
                                            onClick={() =>
                                                deleteSash({
                                                    extraInfo: {
                                                        row_idx,
                                                        row: d,
                                                    },
                                                })
                                            }
                                        >
                                            삭제
                                        </DefaultButton>
                                    </div>
                                </React.Fragment>
                            );
                        })}
                </div>
            </div>
            <div
                className="fixed h-[100%] w-[100%] bg-black opacity-80 top-0 left-0 cursor-pointer z-[90]"
                onClick={closeModal}
            />
        </Portal>
    );
}
